<template>
	<div id="app">
		<div class="preloader">
			<loader object="#ffffff" color1="#ffffff" color2="#17fd3d" size="3" speed="1" bg="#343a40" objectbg="#999793" opacity="60" name="spinning"></loader>
		</div>
		<router-view name="header" v-if="$route.name != 'Login'" />
		<router-view name="default" />
	</div>
</template>

<script>
	import $ from 'jquery'
	import {mapGetters} from 'vuex'
	export default {
		name: 'app',
		data() {
			return {}
		},
		created() {
			$('.preloader').show()
			setTimeout(() => {
				$('.preloader').hide()
			}, 1000)
		},
		methods: {
			...mapGetters({
				isLogin: 'isLogin',
			}),
		},
		mounted() {
			// if (location.protocol != "https:") {
			//   location.href =
			//     "https:" +
			//     window.location.href.substring(window.location.protocol.length);
			// }
		},
	}
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Mitr:200,300,400,500,600,700&display=swap&subset=latin-ext,thai,vietnamese');
	@import url('./assets/index.css');

	#app,
	html,
	body {
		font-family: 'Mitr', sans-serif !important;
		// overflow-x: hidden;
	}
	// div {
	// 	border: 1px solid #8d8c8c3d !important;
	// }
</style>
